module.exports = __webpack_public_path__ + "img/Todo.f4bad5b3.png";